module.exports = __webpack_public_path__ + "static/budget-3e34950ecb3b469d119643efe7ad18e3.png";